import { UsersV2Api } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';

type UseDeleteUser = (
  usersApiV2: UsersV2Api,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, string>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, string>;

export const useDeleteUser: UseDeleteUser = (
  usersApiV2,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    (userId: string) =>
      usersApiV2.deleteUser(tenantId, userId),
    options,
  );
};
